/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { PromotionType } from '../../../types/offers';
import { PaymentsTileContainer, PricingOptionsWrapper } from './VehicleTileCa.styles';
import PaymentOptionsCa from './PaymentOptionsCa';

type PricingOptionsCaProps = {
  offer: PromotionType;
  showOfferDetails: (e: any) => void;
};

const PricingOptionsCa: React.FC<PricingOptionsCaProps> = ({ offer, showOfferDetails }) => {
  return (
    <PricingOptionsWrapper>
      <PaymentsTileContainer>
        <PaymentOptionsCa offer={offer} showOfferDetails={showOfferDetails} />
      </PaymentsTileContainer>
    </PricingOptionsWrapper>
  );
};

export default PricingOptionsCa;
